import args from 'arguments'

const config = {
  apiUrl: args.getArgument('apiUrl') ?? '',
}

export const BASE_API_URL = `${config.apiUrl}/blueprint/servlet/rest`
